import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { hydrateGoalsFromServer, saveMonthlyGoal } from "@/lib/goals";

const GoalsContext = createContext(null);

export function GoalsProvider({ children }) {
  const [version, setVersion] = useState(0);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    hydrateGoalsFromServer()
      .catch(() => {})
      .finally(() => {
        if (cancelled) return;
        setReady(true);
        setVersion((n) => n + 1);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const value = useMemo(
    () => ({
      ready,
      version,
      async saveGoal(amount, month) {
        const saved = await saveMonthlyGoal(amount, month);
        setVersion((n) => n + 1);
        return saved;
      },
    }),
    [ready, version]
  );

  return <GoalsContext.Provider value={value}>{children}</GoalsContext.Provider>;
}

export function useGoals() {
  const ctx = useContext(GoalsContext);
  if (!ctx) throw new Error("useGoals must be used inside GoalsProvider");
  return ctx;
}
